import {
 computed, unref, watch, ref,
} from 'vue';
import { useGetters, useState } from 'vuex-composition-helpers';
import { IOperatorRepository, IOperatorEntity } from '@ve/repositories/operator/types';
import namesRepository from '@ve/repositories/config/index';
import FilterAttributeMethodsOperators from '@ve/components/searchFilters/filterList/desktop/components/filterOperators/filterAttributeMethods/FilterAttributeMethodsOperators';
import { IFilterApplyingItem, IFilterPreviousState } from '../types';

export default function () {
    const { getEntities: operators } = useGetters<IOperatorRepository['getters']>(namesRepository.operatorRepositoryName, ['getEntities']);
    const { previousStateFiltersSerp } = useState<IFilterPreviousState>('previousFilterStore', ['previousStateFiltersSerp']);
    const asyncApplyingItemTourOperators = ref<IFilterApplyingItem | null>(null);

    watch([previousStateFiltersSerp, operators], (state) => { // Запоминаем последних операторов, при сбросе фильтров
        const [filtersState, _operators] = state as [IFilterPreviousState['previousStateFiltersSerp'], IOperatorEntity[]];
        if (!filtersState) {
            asyncApplyingItemTourOperators.value = {
                id: 11,
                nameAction: 'action_operators',
                nameState: 'operators',
                filterAttributeMethod: new FilterAttributeMethodsOperators(_operators),
                valueState: [],
            };
        }
    });

    const asyncApplyingItems = computed(() => [
        unref(asyncApplyingItemTourOperators),
    ].filter((item) => !!item) as IFilterApplyingItem[]);

    return {
        asyncApplyingItems,
    };
}